/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindProductionSitesByOrganizationCertificatesQueryResponse,
  FindProductionSitesByOrganizationCertificatesPathParams,
  FindProductionSitesByOrganizationCertificatesQueryParams,
} from "../types/FindProductionSitesByOrganizationCertificates.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findProductionSitesByOrganizationCertificatesQueryKey = (
  organizationId: FindProductionSitesByOrganizationCertificatesPathParams["organizationId"],
  params: FindProductionSitesByOrganizationCertificatesQueryParams
) =>
  [
    {
      url: "/v1/production-site/find-certificates-production-sites/:organizationId",
      params: { organizationId: organizationId },
    },
    ...(params ? [params] : []),
  ] as const

export type FindProductionSitesByOrganizationCertificatesQueryKey = ReturnType<
  typeof findProductionSitesByOrganizationCertificatesQueryKey
>

/**
 * @summary Find certificate production sites
 * {@link /v1/production-site/find-certificates-production-sites/:organizationId}
 */
export async function findProductionSitesByOrganizationCertificates(
  organizationId: FindProductionSitesByOrganizationCertificatesPathParams["organizationId"],
  params: FindProductionSitesByOrganizationCertificatesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindProductionSitesByOrganizationCertificatesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/production-site/find-certificates-production-sites/${organizationId}`,
    params,
    ...requestConfig,
  })
  return res
}

export function findProductionSitesByOrganizationCertificatesQueryOptions(
  organizationId: FindProductionSitesByOrganizationCertificatesPathParams["organizationId"],
  params: FindProductionSitesByOrganizationCertificatesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findProductionSitesByOrganizationCertificatesQueryKey(
    organizationId,
    params
  )
  return queryOptions<
    ResponseConfig<FindProductionSitesByOrganizationCertificatesQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindProductionSitesByOrganizationCertificatesQueryResponse>,
    typeof queryKey
  >({
    enabled: !!(organizationId && params),
    queryKey,
    queryFn: async ({ signal }) => {
      return findProductionSitesByOrganizationCertificates(
        organizationId,
        params,
        { ...config, signal: config.signal ?? signal }
      )
    },
  })
}

/**
 * @summary Find certificate production sites
 * {@link /v1/production-site/find-certificates-production-sites/:organizationId}
 */
export function useFindProductionSitesByOrganizationCertificates<
  TData =
    ResponseConfig<FindProductionSitesByOrganizationCertificatesQueryResponse>,
  TQueryData =
    ResponseConfig<FindProductionSitesByOrganizationCertificatesQueryResponse>,
  TQueryKey extends QueryKey =
    FindProductionSitesByOrganizationCertificatesQueryKey,
>(
  organizationId: FindProductionSitesByOrganizationCertificatesPathParams["organizationId"],
  params: FindProductionSitesByOrganizationCertificatesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindProductionSitesByOrganizationCertificatesQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ??
    findProductionSitesByOrganizationCertificatesQueryKey(
      organizationId,
      params
    )

  const query = useQuery(
    {
      ...findProductionSitesByOrganizationCertificatesQueryOptions(
        organizationId,
        params,
        config
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
